/** Reset window and dashboard main scroll containers to the top. */
export function scrollToTop() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  document.querySelectorAll('.dashboard-main').forEach((el) => {
    el.scrollTop = 0;
  });
}
